import {Unit, units} from './unit'

const paperSizes = ['letter', 'legal', 'tabloid', 'a3', 'a4', 'a5', 'a6', 'a7'] as const

export type PaperSize = (typeof paperSizes)[number] | {aspectRatio: number; unit: Unit}

export namespace PaperSize {
  export function is(value: unknown): value is PaperSize {
    if (typeof value === 'string') {
      return paperSizes.includes(value as (typeof paperSizes)[number])
    }

    if (typeof value === 'object' && value !== null) {
      const obj = value as {aspectRatio?: unknown; unit?: unknown}
      return typeof obj.aspectRatio === 'number' && units.includes(obj.unit as Unit)
    }

    return false
  }
}

export type PaperSizingBehavior = 'deviceBasedWidth' | 'staticWidth' | 'lockedWidth'

export namespace PaperSizingBehavior {
  export function is(value: unknown): value is PaperSizingBehavior {
    return (
      typeof value === 'string' &&
      (value.startsWith('deviceBasedWidth') || value.startsWith('staticWidth') || value.startsWith('lockedWidth'))
    )
  }
}
